// Centralised English language file for UI text in Weather App
// Add additional languages in equivalent files (e.g., en.ts, it.ts) if needed

const en = {
  app: {
    title: 'WeatherUp!',
    welcome: 'Welcome to WeatherUp! 🌤️',
    subtitle: 'World Weather',
    instructions:
      'Enter a city name to check the weather and stay informed about current conditions. Get started by typing in the search box above. Happy exploring!',
  },
  weather: {
    loading: 'Loading weather data...',
    cardTitle: 'Weather for',
    currentTemp: 'Current Temperature',
    min: 'Min:',
    max: 'Max:',
    localTime: 'Local Time',
    details: 'Weather Details',
    humidity: 'Humidity',
    pressure: 'Pressure',
    windSpeed: 'Wind Speed',
    visibility: 'Visibility',
    feelsLike: 'Feels like',
    // Add more as needed
  },
  search: {
    placeholder: 'Search for a city...',
    ariaLabel: 'Search for a city',
    button: 'Search',
    noResults: 'No locations found.',
  },
};

export default en;
